import React, {useEffect} from "react";
import styled from "styled-components";
import {BlueButton} from "../../buttons/ButtonStyles";

const SearchActionsByDate = ({data, setData, endDate, setEndDate, startDate, setStartDate, isSetByAdvancement}) => {

    useEffect(() => {
        return () => {
            setData(data)
        }
    }, [data, setData])

    useEffect(() => {

       if(isSetByAdvancement){
           if(startDate !== "" && endDate === ""){
               setData(data.filter(d => d.startDate >= startDate && d.advancement !== 100))
           }
           if(endDate !== "" && startDate === ""){
               setData(data.filter(d => d.deadline <= endDate && d.advancement !== 100))
           }
           if((startDate && endDate) !== ""){
               setData(data.filter(d => (d.startDate >= startDate && d.deadline <= endDate && d.advancement !== 100)))
           }

           }
       else{
               if(startDate !== "" && endDate === ""){
                   setData(data.filter(d => d.startDate >= startDate))
               }
               if(endDate !== "" && startDate === ""){
                   setData(data.filter(d => d.deadline <= endDate))
               }
               if((startDate && endDate) !== ""){
                   setData(data.filter(d => (d.startDate >= startDate && d.deadline <= endDate)))
               }
       }

    }, [startDate, setStartDate, endDate, setEndDate, data, setData, isSetByAdvancement])

    const handleStartChange = (e) => {
        setStartDate(e.target.value)
    }

    const handleEndChange = (e) => {
        setEndDate(e.target.value);
    }

    const handleReinitialize = (e) => {
        e.preventDefault();
        setStartDate("");
        setEndDate("");
        setData(data)
    }

    return (
        <DateBox>
            <h3>Période:</h3>
            <input type="date" name="startDate" value={startDate} onChange={handleStartChange}/>
            <input type="date" name="endDate" value={endDate} onChange={handleEndChange}/>
            <Button onClick={handleReinitialize}>Réinitialiser</Button>
        </DateBox>
    )
}

const DateBox = styled.div`

  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 50%;
  
  label, input{
    margin: 0.5rem;
  }
  @media(max-width: 1000px){
    flex-direction: column;
  }
  
  h3{
    font-size: 0.8em;
  }
`

const Button = styled(BlueButton)`
  padding: 0.2rem 0.6rem;
  color: white;
  
  &:hover {
    justify-content: center;
    color: var(--color-blue);
    svg{
      fill: var(--color-blue);
    }
  }
`


export default SearchActionsByDate;
